<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :inline="true" :rules="rules">
        <div class="block">
          <div class="contit">基础信息</div>
          <!-- 选择车牌按钮 -->
          <VehicleSelect :modalList="modalList" :modalList2="modalList2" @onChecked="onChecked">
            <template #start>
              <div class="sinput">
                <SearchField :form="sform" :formCtrl="sformCtrl" @onSearch="onSearch" @onReset="onReset" />
              </div>
            </template>
          </VehicleSelect>
          <!-- 其他控件 -->
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

          <!-- 路线选择控件 -->
          <FormItem v-show="showRoute" :viewMode="routeCtrl.viewMode" :config="routeCtrl" :options="routeCtrl.options"
            :inputValue="routeID" @onChange="onRouteChange" />
        </div>

        <div class="block">
          <div class="contit">装货信息</div>
          <FormItem v-for="(c, i) in formCtrlIn" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput"
            @onSelect="onSelect" />
        </div>

        <div class="block">
          <div class="contit">卸货信息</div>
          <FormItem v-for="(c, i) in formCtrlOut" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput"
            @onSelect="onSelect" />
        </div>

        <div class="block">
          <div class="contit">备注信息</div>
          <FormItem v-for="(c, i) in formCtrl2" :key="'form2Item' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange">
            <template #end>
              <!-- 结款提醒组件 -->
              <PaymentSwitch v-show="form['repaytime']" :value="form['istime']" @onToggle="onToggle" />
            </template>
          </FormItem>

          <!-- 可变文本域备注 -->
          <FormItem v-for="(c, i) in formCtrl3" :key="'form3Item' + i" :ref="'form3Item' + i" :viewMode="c.viewMode"
            :config="c" :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" @onInput="onInput">
          </FormItem>
        </div>

        <ExtraFee :form="form" :formCtrl="formCtrlfee" @onChange="onChange" />
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import nonOrderViewMixin from "./nonOrderViewMixin";

export default {
  mixins: [detailMixin, nonOrderViewMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "运单管理", path: "/order/nocontract" },
        { name: "运单列表", path: "/order/nocontract" },
        { name: "运单添加" },
      ],
      form: {
        cprice: undefined,
        dprice: undefined,
        message: undefined,
        name: undefined,
        shname: undefined,
        drman: undefined,
        drtel: undefined,
        coaddress: undefined,
        predict_loading_date: undefined,
        predict_unloading_date: undefined,
        enman: undefined,
        ertel: undefined,
        enaddress: undefined,
        ischartcar: 1,
        pricing: 1,
      },
      sform: {
        vtype: undefined,
        license: undefined,
      },
      sformCtrl: [
        {
          label: "车辆类型",
          keyName: "vtype",
          type: "select",
          options: [
            // { label: '全部', value: '' },
            // { label: '未回收', value: 1, },
            // { label: '已回收', value: 2, },
          ],
        },
        {
          label: "车牌号",
          keyName: "license",
          type: "text",
        },
      ],
      formCtrl: [
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "select",
          options: [],
        },
        {
          label: "货物名称",
          keyName: "name",
          type: "select",
          err: "请选择货物名称",
          options: [],
        },
        {
          label: "计价方式",
          keyName: "pricing",
          type: "select",
          options: [
            { label: '按重量计费(元/吨)', value: 1 },
            { label: '按体积计费(元/立方米)', value: 2, },
            { label: '按件数计费(元/件)', value: 3, },
            //{ label: '按里程计费(元/公里)', value: 4, },
            { label: '按趟计费(元/趟)', value: 5, },
          ],
        },
        {
          label: "公司单价",
          keyName: "cprice",
          err: "请填写公司单价",
          type: "number",
        },
        {
          label: "司机单价",
          keyName: "dprice",
          err: "请填写司机单价",
          type: "number",
        },
      ],
      modalList: [],
      modalList2: [],
      fhperson: [],
      shperson: [],
      rules: {
        pricing: [
          { required: true, message: "请选择计价方式", trigger: "blur" },
        ],
        cprice: [
          { required: true, message: "请填写公司单价", trigger: "blur" },
        ],
        // dprice: [
        //   { required: true, message: "请填写司机单价", trigger: "blur" },
        // ],
        // message: [
        //   { required: true, message: "请填写信息费", trigger: "blur" },
        // ],
        name: [
          { required: true, message: "请选择货物名称", trigger: "blur" },
        ],
        shname: [
          { required: true, message: "请选择客户名称", trigger: "blur" },
        ],
        drman: [
          { required: true, message: "请填写装货联系人", trigger: "blur" },
        ],
        drtel: [
          { required: true, message: "请填写联系方式", trigger: "blur" },
        ],
        coaddress: [
          { required: true, message: "请填写装货地址", trigger: "blur" },
        ],
        enman: [
          { required: true, message: "请填写卸货联系人", trigger: "blur" },
        ],
        ertel: [
          { required: true, message: "请填写联系方式", trigger: "blur" },
        ],
        enaddress: [
          { required: true, message: "请填写卸货地址", trigger: "blur" },
        ],
        predict_loading_date: [
          { required: true, message: "请填写装货日期", trigger: "blur" },
        ],
        predict_unloading_date: [
          { required: true, message: "请填写卸货日期", trigger: "blur" },
        ],
      },
      formOpen: false,
    };
  },
  methods: {
    detailHandler(formCtrl) {
      formCtrl.map(v => {
        const key = v.keyName
        // console.log(key)
        // 按趟计费不可编辑装/卸货量
        if (this.form['pricing'] == 5 && ['inton', 'unton'].includes(key)) {
          v.disabled = true
        }
        // console.log(v)
        if (![
          // 再派一单时时间不复用
          'id',
          'predict_loading_date',
          'predict_unloading_date',
          'repaytime',
          'istime',
          'order_remark',
          'message',
          'premium',
          'fuel',
          'overlimit',
          // 判断客户是否停用
          'shname',
          'shipperid',
        ].includes(key)) {
          this.form[key] = this.detail[key];
        }
        if ([
          'message',
          'premium',
          'fuel',
          'overlimit'].includes(key)) {
          this.form[key] = '';
        }
      })
      // 派单不复用
      if (!location.href.includes('add')) {
        this.form['istime'] = this.detail['istime'];
      }
      // 查询客户是否停用
      this.setShipper()
      this.$forceUpdate()
      // console.log('detail', { ...this.detail })
      // console.log('form', { ...this.form })
    },
    setShipper() {
      const { shname, shipperid } = this.detail
      if (shname && shipperid && this.custom && this.custom.length) {
        this.custom.map(v => {
          // console.log(v.name, this.form.shname)
          if (v.name == shname) {
            // this.$set(this.form, 'shname', v['name'])
            this.$set(this.form, 'shname', `${v['name']}-${v['member']}`)
          }
          if (v.id == shipperid) {
            this.$set(this.form, 'shipperid', v.id)
            // 查询路线数据
            this.getCustomRoute(v.id)
          }
        })
      }
    },
    handleChange() {
      this.formOpen = !this.formOpen;
    },
    onChecked(arr) {
      // console.log(arr)
      this.form.carid = [...arr]
      // console.log('form', { ...this.form })
    },
    formOrtherValidate() {
      if (!this.form.carid || !this.form.carid.length) {
        this.$message({
          type: 'error',
          message: '请选择车辆！'
        });
      }
      return (this.form.carid && this.form.carid.length)
    },
    setOptions({ product, custom, car_type, additional_fee_options }) {
      // driver.map(v => {
      //   if (v.isorder == 1) {
      //     this.modalList.push(v)
      //   } else {
      //     this.modalList2.push(v)
      //   }
      // })
      this.sformCtrl.map(c => {
        if (c.keyName == 'vtype') {
          c.options = car_type.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })
        }
      })
      this.formCtrl.map(c => {
        if (c.keyName == 'nid' && product && product.length) {
          c.options = product.map(v => {
            return {
              label: v.name,
              value: v.id,
            }
          })
        } else if (c.keyName == 'name' && product && product.length) {
          this.product = [...product]
          c.options = product.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })
        } else if (c.keyName == 'shipperid' && custom && custom.length) {
          c.options = custom.map(v => {
            return {
              label: v.name + '-' + v.member,
              value: v.id,
            }
          })
        } else if (c.keyName == 'shname' && custom && custom.length) {
          this.custom = [...custom]
          c.options = []
          custom.map(v => {
            if (v.customstatus === '在用') {
              c.options.push({
                label: v.name + '-' + v.member,
                value: v.name + '-' + v.member,
              })
            }
          })
          this.setShipper()
        }
      })

      // 附加费用
      if (additional_fee_options && additional_fee_options.length) {
        const o = additional_fee_options
        o.map(v => {
          const ctrl = {
            label: v.authname,
            keyName: v.enname,
            type: "number",
          }
          this.formCtrlfee.push(ctrl)
        })
      }
    },
    onInput({ key, value }) {
      // console.log(key, value, this.form.shipperid)
      const id = this.form.shipperid
      if (key === 'order_remark') {
        if (this.$refs && this.$refs.form3Item0) {
          const dom = this.$refs.form3Item0[0].$el
          // console.log(dom)
          const inner = dom.querySelector('.el-textarea__inner')
          // console.log(inner)
          // console.log(inner.scrollHeight)
          // const oheight = inner.scrollHeight
          inner.style.height = 'auto'; // 重置高度
          // 高度设为auto后scrollHeight会改变，用原始高度判断，一行时强制一行高度，其他情况随内容升高
          // if (oheight < 55) {
          //   inner.style.height = 40 + 'px'
          // } else {
          inner.style.height = inner.scrollHeight + 'px'; // 设置为内容高度
          // }
        }
      } else if (id && value) {
        this.inputSearch(id, key, value)
      } else if (!value) {
        if (key === 'drman') {
          this.formCtrlIn.map(v => {
            if (v.keyName == key) {
              v.options = []
            }
          })
          this.form[key] = value
        } else if (key === 'coaddress') {
          this.formCtrlIn.map(v => {
            if (v.keyName == key) {
              v.options = []
            }
          })
          this.form[key] = value
        } if (key === 'enman') {
          this.formCtrlOut.map(v => {
            if (v.keyName == key) {
              v.options = []
            }
          })
          this.form[key] = value
        } if (key === 'enaddress') {
          this.formCtrlOut.map(v => {
            if (v.keyName == key) {
              v.options = []
            }
          })
          this.form[key] = value
        }
        this.$forceUpdate()
      }
      // console.log({ ...this.form })
    },
    inputSearch(id, key, value) {
      // console.log(id, key, value)
      let url = `${this.baseUrl}/shippervague`;
      const params = {
        id,
      }
      if (key === 'drman') {
        params['fhperson'] = value
      } else if (key === 'coaddress') {
        params['fhdizhi'] = value
      } if (key === 'enman') {
        params['shperson'] = value
      } if (key === 'enaddress') {
        params['shdizhi'] = value
      } else if (!['drman', 'coaddress', 'enman', 'enaddress'].includes(key)) {
        return
      }
      // console.log(url, params)
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          if (key === 'drman') {
            this.formCtrlIn.map(v => {
              if (v.keyName == key) {
                v.options = data.map(v => {
                  return {
                    label: v.member,
                    value: v.id,
                    data: v,
                  }
                })
              }
            })
          } else if (key === 'coaddress') {
            this.formCtrlIn.map(v => {
              if (v.keyName == key) {
                v.options = data.map(v => {
                  return {
                    label: v.address,
                    value: v.id,
                    data: v,
                  }
                })
              }
            })
          } if (key === 'enman') {
            this.formCtrlOut.map(v => {
              if (v.keyName == key) {
                v.options = data.map(v => {
                  return {
                    label: v.member,
                    value: v.id,
                    data: v,
                  }
                })
              }
            })
          } if (key === 'enaddress') {
            this.formCtrlOut.map(v => {
              if (v.keyName == key) {
                v.options = data.map(v => {
                  return {
                    label: v.address,
                    value: v.id,
                    data: v,
                  }
                })
              }
            })
          }
          this.$forceUpdate()
          // console.log([...this.formCtrlIn])
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSelect({ key, value }) {
      // console.log(key, value)
      if (key === 'drman') {
        this.formCtrlIn.map(v => {
          if (v.keyName == key) {
            v.options = []
          }
        })
        this.form[key] = value['member']
        this.form['drtel'] = value['phone']
      } else if (key == 'coaddress') {
        this.formCtrlIn.map(v => {
          if (v.keyName == key) {
            v.options = []
          }
        })
        this.form[key] = value['address']
      } if (key === 'enman') {
        this.formCtrlOut.map(v => {
          if (v.keyName == key) {
            v.options = []
          }
        })
        this.form[key] = value['member']
        this.form['ertel'] = value['phone']
      } if (key === 'enaddress') {
        this.formCtrlOut.map(v => {
          if (v.keyName == key) {
            v.options = []
          }
        })
        this.form[key] = value['address']
      }
      this.$forceUpdate()
    },
    onSearch() {
      this.getCar();
    },
    onReset() {
      this.sform = {
        vtype: undefined,
        license: undefined,
      }
      this.getCar();
    },
    getVtype() {
      let url = "cartype/rec";
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, (res) => {
        // const { msg, data } = res
        console.log(res.data)
        this.sformCtrl.map(c => {
          if (c.keyName == 'vtype') {
            c.options = res.data.map(v => {
              return {
                label: v.name,
                value: v.name,
              }
            })
          }
        })
      }, err => {
        console.log(err)
      })
    },
    getCar() {
      let url = "order/searchcar";
      const params = {
        ...this.sform
      }
      params.userid = this.user.id
      this.post(url, params, (res) => {
        // const { msg, data } = res
        // console.log(res.driver)

        this.modalList = [];
        this.modalList2 = [];
        res.driver.map(v => {
          if (v.isorder == 1) {
            this.modalList.push(v)
          } else {
            this.modalList2.push(v)
          }
        })
      }, err => {
        console.log(err)
      })
    },
    // 添加运单全部字段控件
    getAllCtrls() {
      const formCtrl = [...this.formCtrl]
      const In = this.formCtrlIn
      if (In && In.length) {
        formCtrl.push(...In)
      }
      const Out = this.formCtrlOut
      if (Out && Out.length) {
        formCtrl.push(...Out)
      }
      const f2 = this.formCtrl2
      if (f2 && f2.length) {
        formCtrl.push(...f2)
      }
      const f3 = this.formCtrl3
      if (f3 && f3.length) {
        formCtrl.push(...f3)
      }
      const ff = this.formCtrlfee
      if (ff && ff.length) {
        formCtrl.push(...ff)
      }
      return formCtrl
    },
  },
  created() {
    this.formCtrlIn.map(v => {
      v.viewMode = false
    })
    this.formCtrlOut.map(v => {
      v.viewMode = false
    })
  },
  mounted() {
    this.getOptions({ userid: this.user.id });
    // this.getVtype();
    this.getCar();
  },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.choose {
        display: flex;

        .el-form-item__content {
          flex: 1;
        }
      }

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}

/deep/.el-dialog__body {
  padding: 0 20px 20px 20px;
}

.dialog {
  /deep/ .el-dialog {
    width: 931px;

  }



  .content {
    height: 500px;

    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    /deep/ .is-horizontal {
      display: none;
    }
  }

  .tit {
    line-height: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #303133;
    padding-left: 16px;
    position: relative;
    margin: 0 auto 16px;

    &::before {
      position: absolute;
      left: 0;
      top: 5px;
      content: '';
      width: 10px;
      height: 10px;
      background: #67C23A;
      border-radius: 50%;
    }

    &.tit2 {
      &::before {
        background: #F56C6C;
      }
    }
  }

  .list {
    display: flex;
    flex-wrap: wrap;

    .item {
      background: #FAFAFA;
      border-radius: 6px;
      border: 1px solid #FAFAFA;
      position: relative;
      margin: 0 15px 15px 0;
      position: relative;
      width: 136px;
      box-sizing: border-box;

      &:nth-child(6n) {
        margin-right: 0;
      }

      &.is-checked {
        border-color: #409EFF;
      }

      /deep/ .el-checkbox__input {
        position: absolute;
        right: 15px;
        top: 15px;
      }

      /deep/ .el-checkbox__label {
        padding: 0;
        display: block;
      }

      .row0 {
        padding: 15px;
        height: 14px;
        font-size: 14px;
        color: #303133;
        border-bottom: 1px solid #EBEEF5;
      }

      .row1 {
        padding: 10px 15px;
        height: 14px;
        font-size: 14px;
        color: #909399;
      }
    }
  }

  .btns {
    text-align: center;
    margin-left: 0;
  }
}

.orderlist {
  display: flex;
  flex-wrap: wrap;
  line-height: 20px;

  .item {
    width: 140px;
    margin: 0 15px 15px 0;
    position: relative;
    box-shadow: 0px 0px 8px rgb(0 0 0 / 10%);
    color: #000;
    font-size: 14px;
    padding: 13px 10px;
    border-radius: 2px;

    &:nth-child(8n) {
      margin-right: 0;
    }

    &.is-checked {
      box-shadow: 0px 0px 8px #409EFF;
    }

    /deep/ .el-checkbox__input {
      display: none;
    }

    /deep/ .el-checkbox__label {
      padding: 0;
    }

    .row0 {
      display: flex;
      margin: 5px 0;
    }

    .row1 {
      display: flex;
      margin-bottom: 5px;
    }

    .rowlast {
      display: flex;
      border-bottom: 1px solid #eee;
    }
  }
}

/deep/ .sinput {
  .fillet {
    padding: 0;
  }

  .retrieval {
    margin: 0;

    .el-form-item__content {
      .el-input {
        width: 150px !important;
      }
    }

    .el-form {
      margin-bottom: 0px !important;
    }

    .el-form-item {
      margin: 0 0 10px 0;
    }
  }



}

.el-form-items {
  .tit_label {
    display: flex;

    .title {
      margin-left: 40px;
      cursor: pointer;
    }
  }

}

.tit_label {
  margin: 19px 0 17px 25px;
  font-weight: bold;
  font-size: 18px;
  color: #343434;
}

/deep/ .el-collapse-item__header {
  margin: 17px 0 18px 112px;
  text-align: left;
  font-size: 18px;
  color: #333;
}

/deep/.el-collapse-item__arrow {
  display: none;
}

.el-form-item__content {
  margin-left: 0 !important;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0 !important;
}

/deep/ .el-textarea__inner {
  font-family: "Microsoft Yahei";
}

.el-col-16 {
  margin-left: -48px;
}
</style>
